(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports",
                {
                    url: "/Reports",
                    redirectTo: "Home.Reports.List",
                    template: "<section ui-view></section>"
                });
        }
    ]);

})(window.app);